export default function asset(path: string) {
	return `/${path.replace(/^\/+/, '')}`;
}
